import {
  appConfigurationDetailsFragment,
  appConfigurationFragment
} from "@saleor/fragments/appConfiguration";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { AppConfig, AppConfigVariables } from "./types/AppConfig";
import { AppConfigs, AppConfigsVariables } from "./types/AppConfigs";

const appConfigurations = gql`
  ${appConfigurationFragment}
  ${pageInfoFragment}
  query AppConfigs(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: AppConfigInput
    $sort: AppConfigSortingInput
  ) {
    appConfigs(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      edges {
        node {
          ...AppConfigurationFragment
        }
      }

      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useAppConfigurationsListQuery = makeQuery<
  AppConfigs,
  AppConfigsVariables
>(appConfigurations);

const appConfigurationDetail = gql`
  ${appConfigurationDetailsFragment}
  query AppConfig(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: AppConfigInput
    $sort: AppConfigSortingInput
  ) {
    appConfig(id: $id) {
      ...AppConfigurationDetailsFragment
    }
  }
`;
export const useAppConfigurationDetailQuery = makeQuery<
  AppConfig,
  AppConfigVariables
>(appConfigurationDetail);
